import { useNavigate } from 'react-router-dom';
import { authClient } from '../lib/auth-client';
import { useSessionStore } from '../stores/session';

export default function StaffWelcome() {
  const navigate = useNavigate();
  const { data } = authClient.useSession();
  const email = data?.user?.email;

  async function onSignOut() {
    await authClient.signOut();
    useSessionStore.getState().clear();
    navigate('/login', { replace: true });
  }

  return (
    <main className="min-h-screen bg-[#f7f4ee] px-6 py-10 text-slate-950">
      <div className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-2xl items-center justify-center">
        <section className="w-full rounded-[2rem] border border-white/70 bg-white p-8 text-center shadow-[0_24px_80px_rgba(15,23,42,0.10)] sm:p-10">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-amber-700">Gmail and Calendar</p>
          <h1 className="mt-4 text-3xl font-semibold tracking-tight text-slate-950 sm:text-4xl">
            Google access is connected.
          </h1>
          <p className="mt-4 text-base leading-7 text-slate-600">
            Oracord has the Gmail and Calendar authorization it needs for this account. Return to Setup to confirm the checklist and continue.
          </p>
          {email ? (
            <p className="mt-6 rounded-2xl bg-slate-50 px-4 py-3 text-sm text-slate-600">
              Signed in to Oracord as <span className="font-semibold text-slate-900">{email}</span>
            </p>
          ) : null}
          <div className="mt-8 rounded-2xl border border-emerald-100 bg-emerald-50 px-4 py-4 text-sm leading-6 text-emerald-900">
            Your Google consent is recorded. You can go back to the dashboard and finish any remaining setup steps.
          </div>
          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => navigate('/setup', { replace: true })}
              className="rounded-full bg-slate-950 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-800"
            >
              Return to setup
            </button>
            <button
              type="button"
              onClick={onSignOut}
              className="rounded-full border border-slate-200 bg-white px-5 py-2.5 text-sm font-semibold text-slate-600 shadow-sm transition hover:border-slate-300 hover:bg-slate-50"
            >
              Sign out
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}
